import { ChangeDetectionStrategy, Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { FieldMap, RuleSet } from 'angular2-query-builder/dist/components';
import { FilterType } from 'core/http/project/rule-set/user-templates.service';
import { QueryBuilderDialogService } from 'shared/modules/query-builder/query-builder-dialog/query-builder-dialog.service';

@Component({
  selector: 'app-filter-with-popover',
  templateUrl: './filter-with-popover.component.html',
  styleUrls: ['./filter-with-popover.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterWithPopoverComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FilterWithPopoverComponent implements ControlValueAccessor, OnInit {
  @Input() orderFieldMap: FieldMap = {};
  @Input() withPreview = false;
  @Input() type: FilterType = 'order';
  @Input() onlyIcon = false;

  get ruleSet(): RuleSet {
    return this.filterControl.value;
  }

  filterControl = new UntypedFormControl({ condition: 'and', rules: [] } as RuleSet);

  constructor(private queryBuilder: QueryBuilderDialogService) { }

  private _onChange = (_: any) => {};
  private _onTouched = () => {};

  ngOnInit(): void {
    this.filterControl.valueChanges.subscribe(() => this.notify());
  }

  openFilterDialog(): void {
    this.queryBuilder
      .open(this.type, this.orderFieldMap, this.filterControl.value)
      .subscribe((ruleSet) => {
        if (!ruleSet) {
          return;
        }

        this.filterControl.setValue(ruleSet);
      });
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  writeValue(ruleSet?: RuleSet | null): void {
    this.filterControl.setValue(ruleSet || { condition: 'and', rules: [] } as RuleSet);
    this.notify();
  }

  private notify(): void {
    this._onChange(this.filterControl.value);
    this._onTouched();
  }
}
